import { z } from "zod"

export const providerSchema = z
  .object({
    _id: z.string(),
    name: z.string().optional(),
    email: z.string().optional(),
    unit: z.string().optional(),
    image: z.string().optional(),
    businesses: z
      .array(
        z.object({
          _id: z.string().optional(),
          name: z.string().optional(),
        })
      )
      .optional(),
  })
  .passthrough()
